/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Ccsl_AriaInputs */



/**
* | output |
* | --- |
* | "Export combined continuity and spotting list" |
*
* @param {File_Export_Ccsl_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_ccsl_aria = /** @type {((inputs?: File_Export_Ccsl_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Ccsl_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter la liste combinee de continuite et de reperage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export kombinierte Kontinuitäts- und Spotting-Liste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione di un elenco combinato di continuità e spotting")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объединенный список непрерывности экспорта и спотовых публикаций")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar lista combinada de continuidad y detección")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出综合连续性和定位列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("連続性とスポッティングリストを組み合わせたエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात की जाने वाली संयुक्त निरंतरता और स्पॉटिंग सूची")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lista combinada de continuidade e localização para exportação")
	return /** @type {LocalizedString} */ ("Export combined continuity and spotting list")
});